module.exports = __webpack_public_path__ + "img/re_formation.14439ce4.png";